// Centralized PayPal Messaging Loader and Renderer
// Usage: import { loadPayPalSDK, renderPayPalMessage } from '/Foundation/Common/code/Utils/PayPalMessaging.js';

let sdkLoadingPromise = null;

export function loadPayPalSDK({ clientId, currency, baseURL, components = 'messages' }) {
  if (window.paypal && window.paypal.Messages) return Promise.resolve();
  if (sdkLoadingPromise) return sdkLoadingPromise;

  sdkLoadingPromise = new Promise((resolve, reject) => {
    if (document.querySelector(`script[src^="${baseURL}"]`)) {
      // Paypal script already exists, no need for creating another.
      const check = setInterval(() => {
        if (window.paypal && window.paypal.Messages) {
          clearInterval(check);
          resolve();
        }
      }, 50);
      return;
    }
    const script = document.createElement('script');
    script.src = `${baseURL}?client-id=${clientId}&currency=${currency}&components=${components}`;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return sdkLoadingPromise;
}

export function renderPayPalMessage({ selector, amount, placement = 'product', style = {}, buyerCountry = '' }) {
  if (!window.paypal || !window.paypal.Messages) return;
  const target = document.querySelector(selector);
  if (!target) return;
  if (!buyerCountry) {
      buyerCountry = window._THULEDATA.SitecoreLanguage?.slice(3, 5).toUpperCase();
  }
  window.paypal.Messages({
    amount,
    placement,
    style: {
      layout: 'text',
      logo: { type: 'inline' },
      ...style,
    },
    buyerCountry
  }).render(target);
}
